/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayModelLightResponse } from './DayModelLightResponse';
import {
    DayModelLightResponseFromJSON,
    DayModelLightResponseFromJSONTyped,
    DayModelLightResponseToJSON,
    DayModelLightResponseToJSONTyped,
} from './DayModelLightResponse';

/**
 * Response for special day
 * @export
 * @interface SpecialDayResponse
 */
export interface SpecialDayResponse {
    /**
     * Unique identifier of the special day
     * @type {string}
     * @memberof SpecialDayResponse
     */
    specialDayId?: string;
    /**
     * start of the special days period
     * @type {string}
     * @memberof SpecialDayResponse
     */
    periodStart?: string;
    /**
     * end of the special days period
     * @type {string}
     * @memberof SpecialDayResponse
     */
    periodEnd?: string;
    /**
     * 
     * @type {DayModelLightResponse}
     * @memberof SpecialDayResponse
     */
    dayModel?: DayModelLightResponse;
    /**
     * warning code
     * @type {string}
     * @memberof SpecialDayResponse
     */
    warningCode?: SpecialDayResponseWarningCodeEnum;
    /**
     * true if the special day can be edited
     * @type {boolean}
     * @memberof SpecialDayResponse
     */
    editable?: boolean;
}


/**
 * @export
 */
export const SpecialDayResponseWarningCodeEnum = {
    AppointmentExist: 'APPOINTMENT_EXIST'
} as const;
export type SpecialDayResponseWarningCodeEnum = typeof SpecialDayResponseWarningCodeEnum[keyof typeof SpecialDayResponseWarningCodeEnum];


/**
 * Check if a given object implements the SpecialDayResponse interface.
 */
export function instanceOfSpecialDayResponse(value: object): value is SpecialDayResponse {
    return true;
}

export function SpecialDayResponseFromJSON(json: any): SpecialDayResponse {
    return SpecialDayResponseFromJSONTyped(json, false);
}

export function SpecialDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialDayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'specialDayId': json['specialDayId'] == null ? undefined : json['specialDayId'],
        'periodStart': json['periodStart'] == null ? undefined : json['periodStart'],
        'periodEnd': json['periodEnd'] == null ? undefined : json['periodEnd'],
        'dayModel': json['dayModel'] == null ? undefined : DayModelLightResponseFromJSON(json['dayModel']),
        'warningCode': json['warningCode'] == null ? undefined : json['warningCode'],
        'editable': json['editable'] == null ? undefined : json['editable'],
    };
}

export function SpecialDayResponseToJSON(json: any): SpecialDayResponse {
    return SpecialDayResponseToJSONTyped(json, false);
}

export function SpecialDayResponseToJSONTyped(value?: SpecialDayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'specialDayId': value['specialDayId'],
        'periodStart': value['periodStart'],
        'periodEnd': value['periodEnd'],
        'dayModel': DayModelLightResponseToJSON(value['dayModel']),
        'warningCode': value['warningCode'],
        'editable': value['editable'],
    };
}

